//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TabelaGenerica from '../../../../../shared-components/generico/TabelaGenerica';
import mdAutocomplete from '../../../../../shared-components/autocomplete/mdAutocomplete';
import FiltrosDash from './FiltrosDashPagamento';
import RateioModal from './RateioModal';

import {
  getMoney,
} from '../../../../../common/functions/helpers';
import { prepareResponseData } from '../../../../../common/functions/http';


export default {
  extends: TabelaGenerica,
  props: {
    contrato: Object,
  },
  data() {
    return {
      workflowPassosResources: this.$api.workflowPassos(this.$resource),
      pagamentoResources: this.$api.pagamentoGestao(this.$resource),
      dashboardPagamentoResources: this.$api.dashboardPagamento(this.$resource),
      canPost: false,
      somenteLeitura: false,
      nomContato: '',
      hasFilter: false,
      itemSelecionado: null,
      justificativa: '',
      justificativaGrid: 'Sem justificativa.',
      filtro: {
        status: 'AGUARDANDO_APROVACAO',
      },
      filtroCopy: {},
      statusOpcoes: [
        { status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') },
        { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) },
        { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) },
        { status: 'EM_FLUXO', descricao: this.$tc('status_entidade.em_fluxo', 1) },
        { status: 'EM_ANALISE', descricao: this.$tc('status_entidade.em_analise', 1) },
        { status: 'AGUARDANDO_PAGAMENTO', descricao: this.$tc('status_entidade.aguardando_pagamento', 1) },
        { status: 'CANCELADO', descricao: this.$tc('status_entidade.cancelado', 1) },
        { status: 'TRANSFERIDO', descricao: this.$tc('status_entidade.transferido', 1) },
        { status: 'CONDICAO_NAO_ATENDIDA', descricao: this.$tc('status_entidade.condicao_nao_atendida', 1) },
      ],
      tableRowsRateio: [],
      tableHeaderRateio: [
        {
          name: this.$tc('label.cod_produto', 1),
          sortType: 'codigo_produto',
          classes: [],
        },
        {
          name: this.$tc('label.desc_produto', 1),
          sortType: 'nom_produto',
          classes: [],
        },
        {
          name: this.$tc('label.valor', 1),
          sortType: 'valor',
          classes: [''],
        },
        {
          name: this.$tc('label.composicao', 1),
          sortType: 'composicao',
          classes: [''],
        },
      ],
    };
  },
  computed: {
    hasSingleRowSelected() {
      return this.selected && this.selected.length === 1;
    },
  },
  components: {
    mdAutocomplete,
    FiltrosDash,
    RateioModal,
  },
  methods: {
    prepareResponseData,
    getMoney,
    clickOnRow(row = null, index) {
      this.$emit('ACORDOTABELA_CLICK_LINHA', this.contrato, row, index);
    },
    defaultClose() {
      this.requestCleanFiltro();
      this.getLimpaReferenciasJustificativa();
      this.requestRefreshFilteredList();
      this.$refs.modal.close();
    },
    getLimpaReferenciasJustificativa() {
      this.$refs.inputJustificativaAnalise.hasValue = false;
      this.$refs.inputJustificativaAnalise.inputLength = 0;
      this.$refs.inputJustificativaAprovar.hasValue = false;
      this.$refs.inputJustificativaAprovar.inputLength = 0;
      this.$refs.inputJustificativaReprovar.hasValue = false;
      this.$refs.inputJustificativaReprovar.inputLength = 0;
      this.$forceUpdate();
    },
    requestFecharModaisDefault() {
      this.$refs.modalReprovar.close();
      this.$refs.modalAnalise.close();
      this.$refs.modalAprovar.close();
      this.$refs.modalComentario.close();
      this.justificativa = '';
    },
    requestRefreshFilteredList() {
      this.$emit('ACORDOTABELA_REFRESH');
    },
    filtrarModal(filtro) {
      this.filtro = filtro;
      this.requestBuscarNegociacoesFilter();
    },
    requestCleanFiltro() {
      this.filtro.tipoAcordo = '';
      this.filtro.status = '';
      this.filtro.tipoLinhaOrcamento = '';
      this.filtro.marca = '';
      this.filtro.linhaProduto = '';
      this.filtro.familia = '';
      this.filtro.produto = '';
      this.filtro.cliente = '';
      this.justificativa = '';

      if (this.filtro.idCliente) {
        delete this.filtro.idCliente;
      }
      if (this.filtro.idExtensao) {
        delete this.filtro.idExtensao;
      }
      if (this.filtro.idLinhaProduto) {
        delete this.filtro.idLinhaProduto;
      }
      if (this.filtro.idMarca) {
        delete this.filtro.idMarca;
      }
      if (this.filtro.idProduto) {
        delete this.filtro.idProduto;
      }
      if (this.filtro.idTipoLinhaOrcamento) {
        delete this.filtro.idTipoLinhaOrcamento;
      }
    },
    requestVoltarTelaInicial() {
      this.$refs.modal.close();
    },
    requestModalEnviarNegociacaoAnalise(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAnalise.open();
      this.itemSelecionado = row;
    },
    requestModalAprovarPassoNegociacao(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalAprovar.open();
      this.itemSelecionado = row;
    },
    requestModalComentarioOpcional(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalComentario.open();
      this.itemSelecionado = row;
    },
    requestModalReprovarApuracaoNegociacao(row) {
      this.getLimpaReferenciasJustificativa();
      this.$refs.modalReprovar.open();
      this.itemSelecionado = row;
    },
    requestAprovarPassosFluxoAcordo() {
      const item = this.itemSelecionado;
      this.workflowPassosResources.aprovarPassosAcordo({ idAcordo: item.id },
        { observacao: this.justificativa })
        .then(() => {
          this.requestFecharModaisDefault();
        })
        .catch((err) => {
          this.$error(this, err);
          // this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    requestEnviarNegociacaoParaAnalise() {
      const item = this.itemSelecionado;
      this.workflowPassosResources.enviarAcordoAnalise({ idAcordo: item.id },
        { observacao: this.justificativa })
        .then(() => {
          this.requestFecharModaisDefault();
        })
        .catch((err) => {
          this.$error(this, err);
          // this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    requestRateio(id) {
      this.dashboardPagamentoResources.listarRateio({ id })
      .then((response) => {
        this.tableRowsRateio = response.data;
        this.$refs.dialogRateio.open();
      });
    },
    requestReprovarPassosNegociacao() {
      const item = this.itemSelecionado;
      this.workflowPassosResources.reprovarAcordo({ idAcordo: item.id },
        { observacao: this.justificativa })
        .then(() => {
          this.requestFecharModaisDefault();
        })
        .catch((err) => {
          this.$error(this, err);
          // this.$toast.create(this.$t(err), 'snack', 3E3);
        });
    },
    requestBuscarNegociacoesFilter() {
      this.$emit('ACORDOTABELA_FILTER', this.filtro, this.requestVoltarTelaInicial);
    },
    requestCancelarPagamento(row) {
      const id = row.id;
      const ids = [id];
      this.pagamentoResources.cancelar({ ids })
      .then(() => {
        this.$emit('ACORDOTABELA_FILTER', this.filtro, this.requestVoltarTelaInicial);
      });
    },
    setTipoInvestimentoOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
      this.filtro.tipoLinhaOrcamento = hit.descTipoOrcamento;
    },
    setMarca(hit) {
      this.filtro.idExtensao = hit.id;
      this.filtro.marca = hit.nomExtensao;
    },
    setFamilia(hit) {
      this.filtro.idMarca = hit.id;
      this.filtro.familia = hit.nomExtensao;
    },
    setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
      this.filtro.linhaProduto = hit.nomExtensao;
    },
    setProduto(hit) {
      this.filtro.idProduto = hit.id;
      this.filtro.produto = hit.nomProduto;
    },
    setCliente(hit) {
      this.filtro.idCliente = hit.id;
      this.filtro.cliente = hit.nomCliente;
    },
    setUnidadeNegocio(hit, row) {
      this.dependenciaUnidadeNegocio = {
        idUnidadeNegocio: hit.id,
        nomExtensao: hit.nomExtensao,
        unidadeNegocio: hit.nomExtensao,
      };
      this.updateItemDependency(row, 'dependencias', this.dependenciaUnidadeNegocio);
    },
    showJustificativa(row) {
      this.justificativa = row.justificativa;
      this.$refs.dialogJustificativa.open();
    },
  },
  mounted() {
    this.filtroCopy = this.filtro;
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/PagamentosSolicitadosTabelaDash.vue?vue&type=script&lang=js&